
import { MdDashboard, MdFormatListBulletedAdd, MdCategory, MdContactMail, MdAssignmentReturn, MdLockClock   } from "react-icons/md";
import { ImProfile } from "react-icons/im";
import { GiSellCard, GiExpense } from "react-icons/gi";
import { TbReport, TbPackages, TbAdjustmentsDown } from "react-icons/tb";
import { FaUsers } from "react-icons/fa";
import { IoLayersSharp } from "react-icons/io5";
import {LuPackagePlus } from "react-icons/lu"
import { GrStakeholder } from "react-icons/gr";

const menu = [
  {
    title: "Dashboard",
    icon: <MdDashboard />,
    path: "/dashboard",
  },
  {
    title: "Attributes",
    icon: <IoLayersSharp />,
    path: "/Attributes",
  },
  {
    title: "Category",
    icon: <MdCategory />,
    path: "/Category",
  },
  {
    title: "Products",
    icon: <TbPackages />,
    path: "/Products",
  },
    {
    title: "Product Stock Batches",
    icon: <LuPackagePlus />,
    path: "/product-batches",
  },
  {
    title: "Sales",
    icon: <GiSellCard />,
    path: "/Sales",
  },
  {
    title: "Sale Returns",
    icon: <MdAssignmentReturn />,
    path: "/Sale-Returns",
  },
  {
    title: "Shift Closing",
    icon: <MdLockClock />,
    path: "/Shift-Closing",
  },
  {
    title: "Stock Adjustment",
    icon: <TbAdjustmentsDown />,
    path: "/Stock-Adjustment",
  },
  {
    title: "Orders",
    icon: <MdFormatListBulletedAdd />,
    path: "/Orders",
  },
  {
    title: "Expenses",
    icon: <GiExpense />,
    path: "/Expenses",
  },
  {
    title: "Reports",
    icon: <TbReport />,
    path: "/Reports",
  },
  {
    title: "Customers",
    icon: <GrStakeholder />,
    path: "/customer",
  },
  {
    title: "User Management",
    icon: <FaUsers />,
    path: "/Users",
  },
  {
    title: "Contact Us",
    icon: <MdContactMail />,
    path: "/ContactUs",
  },
  {
    title: "Profile",
    icon: <ImProfile />,
    path: "/Profile",
  },
];

export default menu;
